import i18next from 'i18next'
import React from 'react'
import { Link } from '../../../utils/links'

export const TagsLayout = (props: {
  tags: {
    title: string
    url: string
  }[]
}) =>
  props.tags.length > 0 ? (
    <aside className="block--tags container--s gutter--m">
      <div className="block__inner">
        <h2 className="block__title typo--xs">
          {i18next.t('misc:moreAbout')} <span className="sr-text">{i18next.t('misc:relatedSubjects')}</span>
        </h2>
        <ul className="block__list">
          {props.tags.map((tag) => (
            <li className="block__item">
              <Link url={tag.url} rel="tag" className="button--tag">
                <span className="button__label">{tag.title}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  ) : (
    <></>
  )

export const PreviewHeaderLayout = (props: { slug: string }) => {
  const { slug } = props
  return (
    <div className='notification'>
      <div className='notification__inner container--l gutter--m text--styled bg--orange'>
        <p className='notification__text'>{i18next.t('global:PreviewMessage')} - <a href={slug} target="_blank">{i18next.t("global:PreviewLink")}</a></p>
      </div>
    </div>
  )
}

export const isPreviewPage = window.location.pathname.startsWith("/preview")
